import React from 'react'

function Dashboard() {
    return <>Dashboard</>
}

export default Dashboard